export default {
  importResult: {
    processing: 'กำลังประมวลผลการนำเข้า กรุณารอสักครู่',
    counts: 'บันทึกสำเร็จ {{success}} รายการ ไม่ผ่าน {{error}} รายการ',
    success: 'นำเข้าข้อมูลสำเร็จ',
    partial_success:
      'บันทึกสำเร็จ {{success}} รายการ ไม่ผ่าน {{error}} รายการ กรุณาแก้ไขและนำเข้าเฉพาะรายการที่ไม่ผ่าน',
    failure: 'ข้อมูลไม่ผ่านทั้งหมด ไม่มีรายการถูกบันทึก',
    failed: 'ระบบประมวลผลล้มเหลว',
    cancel: 'การนำเข้าถูกยกเลิก',
    download: 'ดาวน์โหลดรายการที่ไม่ผ่าน',
    downloadError: 'ดาวน์โหลดไม่สำเร็จ: {{message}}'
  },
  templateDownload: {
    label: 'ดาวน์โหลดไฟล์ตัวอย่าง — {{category}}',
    unavailable: 'ยังไม่มีไฟล์ตัวอย่างสำหรับหมวดนี้'
  },
  ioRecords: {
    view: 'ดูข้อมูล I/O',
    title: 'ข้อมูล I/O ปัจจุบัน',
    company: 'บริษัท: {{company}}',
    note: 'ข้อมูล I/O ปัจจุบัน อาจรวมหลายงานนำเข้าและการแก้ไขภายหลัง ไม่ใช่ผลเฉพาะงานใดงานหนึ่ง',
    'filter-note':
      'เลือกช่วงวันที่ให้ครบอย่างน้อยหนึ่งชุด โดยข้อมูลต้องตรงทุกเงื่อนไขที่เลือก วันที่สร้างและอัปเดตใช้เวลาไทย (UTC+7) วันที่อัปเดตคือการแก้ไขล่าสุดจากทุก flow',
    workDate: 'วันที่ทำงาน',
    createdDate: 'วันที่สร้างรายการ',
    updatedDate: 'วันที่อัปเดตล่าสุด',
    From: 'ตั้งแต่',
    To: 'ถึง',
    employee_code: 'รหัสพนักงาน',
    branch_code: 'สาขา',
    date: 'วันที่ทำงาน',
    time_in: 'เวลาเข้า',
    time_out: 'เวลาออก',
    pis_master_shift_code: 'กะ',
    input_type: 'แหล่งข้อมูล',
    io_code: 'รหัส I/O',
    createdAt: 'วันที่สร้าง (เวลาไทย)',
    updatedAt: 'วันที่อัปเดต (เวลาไทย)',
    'previous-day': 'วันก่อนหน้า',
    'next-day': 'วันถัดไป',
    search: 'ค้นหา',
    clear: 'ล้างตัวกรอง',
    refresh: 'รีเฟรช',
    loading: 'กำลังโหลดข้อมูล I/O…',
    'load-error': 'โหลดข้อมูล I/O ไม่สำเร็จ โปรดลองอีกครั้ง',
    invalid:
      'กรุณาเลือกช่วงวันที่อย่างน้อยหนึ่งชุด โดยกรอกวันเริ่มต้นและสิ้นสุดให้ถูกต้องและไม่กลับลำดับ',
    empty: 'ไม่พบข้อมูล I/O ตามเงื่อนไขนี้',
    'page-summary': 'หน้า {{page}} · {{total}} รายการ',
    previous: 'ก่อนหน้า',
    next: 'ถัดไป',
    close: 'ปิด'
  },
  history: {
    title: 'ประวัติการนำเข้า',
    'type-title': 'ประวัติการนำเข้า {{type}}',
    'scoped-note':
      'แสดงเฉพาะประวัติที่บันทึกแล้วของประเภทนี้ ไม่รวมงานที่ยังเข้าคิวหรือล้มเหลวโดยไม่มีประวัติ เลือกเวลาทำงาน → SFTP เพื่อดูงาน SFTP',
    company: 'ประวัติการนำเข้าที่บันทึกแล้วของบริษัท {{company}}',
    filter: 'ประเภทการนำเข้า',
    all: 'ทุกประเภท',
    types: {
      time: 'เวลาทำงาน',
      allowance: 'ค่าตอบแทนพิเศษ',
      ot: 'OT',
      mapping: 'Card Mapping'
    },
    statuses: {
      success: 'สำเร็จ',
      partial_success: 'สำเร็จบางส่วน',
      failure: 'ล้มเหลว',
      cancel: 'ยกเลิก',
      pending: 'รอดำเนินการ',
      duplicate: 'ข้อมูลซ้ำ',
      invalid: 'ข้อมูลไม่ถูกต้อง'
    },
    refresh: 'รีเฟรช',
    loading: 'กำลังโหลดประวัติการนำเข้า…',
    'load-error': 'โหลดประวัติการนำเข้าไม่ได้ กรุณาลองใหม่',
    empty: 'ยังไม่มีประวัติการนำเข้า',
    note: 'แสดงเฉพาะประวัติที่ระบบบันทึกแล้ว ไม่รวมงานที่ยังเข้าคิวหรือล้มเหลวโดยไม่มีประวัติ งาน SFTP แสดงแยกด้านล่าง',
    'time-actor': 'เวลา / ผู้เริ่มงาน',
    'type-file': 'ประเภท / ไฟล์',
    status: 'สถานะ',
    detail: 'รายละเอียด',
    'open-detail': 'ดูผลการนำเข้าไฟล์ {{file}}',
    'detail-title': 'ผลการนำเข้า',
    'page-summary': 'หน้า {{page}} · {{total}} รายการ',
    previous: 'ก่อนหน้า',
    next: 'ถัดไป',
    unavailable:
      'อ่านรายละเอียดผลที่บันทึกไว้ไม่ได้ แต่ยังแสดงรายการประวัตินี้ได้',
    'empty-result': 'ไม่มีผลรายแถวที่บันทึกไว้',
    row: 'แถว',
    employee: 'รหัสพนักงาน',
    message: 'รายละเอียดผล',
    close: 'ปิด'
  },
  ui: {
    title: 'นำเข้าข้อมูล',
    description:
      'นำเข้าเวลาทำงาน ค่าตอบแทนพิเศษ หรือ OT แล้วตรวจไฟล์ก่อนยืนยัน',
    'file-format': 'เลือกรูปแบบไฟล์',
    'drop-here': 'ลากไฟล์มาวาง หรือ',
    browse: 'เลือกไฟล์',
    'selected-files': 'ไฟล์ที่เลือก ({{count}})',
    'no-file': 'ยังไม่ได้เลือกไฟล์',
    'remove-file': 'ลบไฟล์ {{name}}',
    'file-status': {
      staged: 'ยังไม่ได้ส่ง',
      sending: 'กำลังส่ง',
      queued: 'รับงานเข้าคิวแล้ว',
      review: 'โปรดตรวจผลการส่ง'
    },
    'drop-file': 'หย่อนไฟล์{{type}}',
    'choose-or-drop': 'ลากไฟล์มาวาง หรือกดเพื่อเลือกไฟล์',
    'excel-files': '.xlsx / .csv · เลือกครั้งละ 1 ไฟล์',
    'sftp-files': '.txt / .csv · สูงสุด 10 ไฟล์',
    company: 'บริษัท {{company}}',
    types: 'ประเภทข้อมูลนำเข้า',
    time: 'เวลาทำงาน',
    allowance: 'ค่าตอบแทนพิเศษ',
    ot: 'OT',
    mapping: 'Card Mapping',
    'mapping-disabled':
      'บริษัทนี้ไม่ได้เปิดใช้งานการนำเข้า Card Mapping แต่ยังดูประวัติที่บันทึกไว้ด้านล่างได้',
    'time-title': 'นำเข้าเวลาทำงาน',
    'time-description': 'Excel / CSV หรือไฟล์สแกนเวลา SFTP',
    'allowance-title': 'นำเข้าค่าตอบแทนพิเศษ',
    'allowance-description': 'Special allowance · Excel / CSV',
    'ot-title': 'นำเข้าการทำงานล่วงเวลา',
    'ot-description': 'OT · Excel / CSV',
    'mapping-title': 'จับคู่รหัสบัตรพนักงาน',
    'mapping-description': 'Card mapping · Excel / CSV',
    'upload-time': 'อัปโหลด Excel / CSV',
    upload: 'อัปโหลดไฟล์',
    confirm: 'ยืนยันนำเข้า',
    sync: 'Sync SFTP',
    'refresh-result': 'รีเฟรชผล',
    'job-status': 'สถานะงาน: {{status}}'
  },
  'sftp-claim': {
    title: 'มีงาน SFTP ล็อกการนำเข้าของบริษัทนี้อยู่',
    job: 'รหัสงาน',
    detail: 'ดูงาน',
    release: 'ปลดล็อกงาน',
    'confirm-title': 'ยืนยันปลดล็อกงาน',
    confirm: 'ปลดล็อกการนำเข้า SFTP ของบริษัท {{company}} หรือไม่?',
    'saved-data': 'ข้อมูลที่บันทึกแล้วและประวัติงานจะยังอยู่',
    'no-retry': 'งานเดิมจะไม่ทำต่อหรือส่งซ้ำโดยอัตโนมัติ',
    'pending-data':
      'งานครั้งถัดไปอาจประมวลผลข้อมูลดิบค้างของบริษัทตามขั้นตอน I/O เดิม',
    reviewed: 'ฉันตรวจสอบผลและข้อมูลที่บันทึกของงานนี้แล้ว',
    cancel: 'ยกเลิก',
    'confirm-release': 'ยืนยันปลดล็อก',
    refresh: 'รีเฟรช',
    'load-error': 'ตรวจสอบสถานะล็อกไม่ได้ โปรดรีเฟรชก่อนปลดล็อก',
    'release-error':
      'ปลดล็อกไม่สำเร็จหรือยังยืนยันผลไม่ได้ โปรดรีเฟรชและตรวจงานที่ล็อกอยู่ก่อนลองใหม่',
    reasons: {
      'no-claim': 'ไม่มีงานล็อกบริษัทนี้อยู่',
      'not-reviewable': 'งานยังไม่ถึงผล I/O ที่ปลดล็อกหลังตรวจสอบได้',
      'processing-error':
        'การหยุดหรือข้อผิดพลาดนี้ยังต้องให้ผู้ดูแลตรวจสอบ ไม่สามารถปลดด้วยปุ่มนี้ได้',
      'queue-missing': 'ไม่พบงานในคิว ต้องให้ผู้ดูแลตรวจว่าการประมวลผลหยุดแล้ว',
      'queue-mismatch': 'ข้อมูลคิวไม่ตรงกับงานนี้ ต้องให้ผู้ดูแลตรวจสอบ',
      'worker-not-completed':
        'worker ยังไม่อยู่ในสถานะจบที่ตรงกับงานนี้ โปรดรีเฟรชและตรวจสอบงานก่อนปลดล็อก',
      'worker-locked': 'ยังมีล็อกของ worker อยู่ จึงยังปลดไม่ได้',
      'queue-unavailable':
        'ตรวจสอบสถานะ worker ไม่ได้ โปรดรีเฟรชหรือติดต่อผู้ดูแล',
      'claim-changed': 'ข้อมูลของงานเปลี่ยนไป โปรดรีเฟรชก่อนดำเนินการต่อ'
    }
  },
  'sftp-tracking': {
    'time-actor-company': 'เวลา / ผู้เริ่มงาน',
    'status-step': 'สถานะ / ขั้นตอน',
    'company-results': 'ติดตามผลการนำเข้าของบริษัท {{company}}',
    'saved-rows': '{{rows}} แถวบันทึกแล้ว',
    'shown-jobs': 'แสดง {{rows}} งาน',
    title: 'งานนำเข้า SFTP',
    note: 'ข้อมูลดิบบันทึกแล้วไม่ได้หมายความว่า I/O สำเร็จ โปรดตรวจทั้งสองส่วนก่อนนำเข้าซ้ำ',
    refresh: 'รีเฟรช',
    time: 'เวลา',
    actor: 'ผู้เริ่มงาน',
    source: 'แหล่งไฟล์',
    company: 'บริษัท',
    step: 'ขั้นตอน',
    status: 'สถานะ',
    counts: {
      rawSaved: 'ข้อมูลดิบบันทึกแล้ว',
      error: 'ผิดพลาด',
      hold: 'Hold',
      pending: 'ยังไม่ได้ทำ',
      review: 'แถวต้องตรวจ'
    },
    detail: 'รายละเอียด',
    empty: 'ยังไม่มีงาน SFTP',
    older: 'งานก่อนหน้า',
    latest: 'งานล่าสุด',
    job: 'รหัสงาน',
    parent: 'งานต้นทาง',
    backup: 'Backup',
    'hold-only': 'แสดงเฉพาะ Hold',
    hidden:
      'แสดงข้อมูลต้นฉบับเฉพาะแถวของบริษัทที่เปิดอยู่ แถวที่ยังระบุบริษัทไม่ได้หรือเป็นบริษัทอื่นจะซ่อนข้อมูลพนักงาน',
    select: 'เลือก',
    file: 'ไฟล์',
    line: 'บรรทัด',
    reason: 'เหตุผล',
    original: 'บรรทัดต้นฉบับ',
    redacted: 'ซ่อนข้อมูล',
    previous: 'ก่อนหน้า',
    next: 'ถัดไป',
    resume: 'นำเข้า Hold ต่อ',
    io: 'สถานะการประมวลผล I/O',
    'io-note':
      'แสดงเฉพาะสถานะการประมวลผล I/O ระบบไม่เก็บรายละเอียดผล I/O รายแถว โดย I/O อาจรวมข้อมูลค้างเดิมของบริษัท',
    close: 'ปิด',
    loading: 'กำลังโหลด',
    'confirm-title': 'ยืนยันนำเข้า Hold',
    confirm:
      'นำเข้าแถวที่เลือก {{count}} แถวในบริษัท {{company}} หรือไม่? ระบบจะตรวจข้อมูลล่าสุดอีกครั้ง',
    cancel: 'ยกเลิก',
    queued: 'รับงานแล้ว โปรดติดตามผลในตาราง SFTP',
    'load-error': 'โหลดผลไม่สำเร็จ โปรดรีเฟรชก่อนลองอีกครั้ง',
    'resume-error':
      'ยังยืนยันผลไม่ได้หรือแถวถูกเลือกไปแล้ว โปรดรีเฟรชและตรวจงานก่อนลองใหม่',
    statuses: {
      queued: 'รอประมวลผล',
      processing: 'กำลังทำ',
      pending: 'ยังไม่ได้ทำ',
      claimed: 'ถูกเลือกนำเข้าต่อ',
      writing: 'ต้องตรวจสอบการเขียน',
      'raw-saved': 'ข้อมูลดิบบันทึกแล้ว',
      error: 'ผิดพลาด',
      hold: 'มี Hold',
      success: 'สำเร็จ',
      partial: 'สำเร็จบางส่วน',
      partial_success: 'สำเร็จบางส่วน',
      'no-data': 'ไม่มีข้อมูล',
      'needs-review': 'ต้องตรวจสอบ',
      failed: 'ล้มเหลว',
      unsupported: 'ไม่รองรับไฟล์ตั้งแต่ 10 MiB',
      'not-run': 'ยังไม่ได้ทำ',
      cancel: 'I/O ไม่สำเร็จ',
      failure: 'ล้มเหลว',
      invalid: 'ข้อมูลผิดรูป',
      duplicate: 'ข้อมูลซ้ำ'
    },
    sources: {
      sync: 'Sync SFTP',
      upload: 'ไฟล์จากเครื่อง',
      hold: 'นำเข้า Hold ต่อ'
    },
    steps: {
      accepted: 'รับงาน',
      'read-files': 'อ่านไฟล์',
      'parse-files': 'แปลงไฟล์',
      'classify-company': 'แยกบริษัท',
      'raw-import': 'บันทึกข้อมูลดิบ',
      'io-processing': 'ประมวลผล I/O',
      completed: 'จบงาน'
    },
    backups: {
      'not-applicable': 'ไม่เกี่ยวข้อง/ยังไม่เริ่ม',
      pending: 'ยังไม่ยืนยันการย้าย',
      moved: 'ย้ายแล้ว'
    },
    reasons: {
      'other-company': 'เป็นบริษัทอื่น',
      'invalid-row': 'รูปแบบแถวไม่ถูกต้อง',
      'invalid-date': 'วันที่หรือเวลาไม่ถูกต้อง',
      'ambiguous-company': 'ระบุบริษัทหรือพนักงานไม่ได้แน่นอน',
      'employee-or-mapping-not-found':
        'ไม่พบพนักงานหรือ Card Mapping ที่ใช้ได้',
      'branch-not-found': 'ไม่พบสาขาพนักงาน',
      'duplicate-or-invalid': 'ข้อมูลซ้ำหรือไม่ผ่านการตรวจเดิม',
      'worker-interrupted':
        'worker หยุดหรือผลไม่ครบ โปรดให้ผู้ดูแลตรวจข้อมูลก่อนทำต่อ',
      'ot-queue-failed':
        'บันทึก I/O แล้ว แต่ยังยืนยันการส่งคิวคำนวณ OT ไม่ได้ โปรดตรวจ log ของ worker ก่อนทำต่อ ระบบไม่ส่งซ้ำอัตโนมัติ',
      'processing-stopped':
        'หยุดกลางงาน ข้อมูลที่บันทึกแล้วคงอยู่ ไม่ retry อัตโนมัติ',
      'acceptance-failed':
        'ยังยืนยันการรับงานไม่ได้ โปรดตรวจ Tracking ก่อนลองใหม่',
      'company-busy':
        'มีงานบริษัทนี้ค้างอยู่ โปรดให้ผู้ดูแลตรวจงานเดิมก่อนเริ่มใหม่'
    },
    'counts-title': 'จำนวนแถว'
  },
  'sftp-upload': {
    button: 'นำเข้าไฟล์ SFTP',
    title: 'นำเข้าไฟล์ SFTP จากเครื่อง',
    limits:
      'รับ TXT หรือ CSV แบบ UTF-8 สูงสุด 10 ไฟล์ ไฟล์ละไม่เกิน 5 MiB รวมไม่เกิน 20 MiB โดยใช้รูปแบบไฟล์เดียวกับ Sync SFTP',
    scope:
      'ใช้บริษัทที่เปิดหน้านี้ และสาขาของพนักงานแต่ละแถว แถวบริษัทอื่นหรือระบุบริษัทไม่ได้จะพักเป็น Hold',
    choose: 'เลือกไฟล์',
    sizes: 'ขนาดไฟล์ที่เลือก',
    submit: 'นำเข้า',
    close: 'ปิด',
    'new-batch': 'เลือกไฟล์ชุดใหม่',
    processing: 'กำลังส่งไฟล์เพื่อสร้างงานนำเข้า โปรดรอสักครู่',
    complete: 'นำเข้าไฟล์และประมวลผลเวลาเข้า–ออกสำเร็จ',
    'review-results':
      'บางขั้นตอนยังไม่สำเร็จ โปรดตรวจผลและประวัติการนำเข้าก่อนนำเข้าอีกครั้ง',
    stopped:
      'หยุดประมวลผลแล้ว ข้อมูลที่บันทึกไปก่อนหน้ายังคงอยู่ โปรดตรวจผลแต่ละไฟล์และประวัติก่อนนำเข้าอีกครั้ง',
    rejected:
      'ระบบไม่รับชุดไฟล์นี้ โปรดตรวจชนิด ขนาด จำนวนไฟล์ และเนื้อหาข้อความ UTF-8',
    'access-error':
      'ไม่สามารถใช้งานการนำเข้านี้ได้ โปรดตรวจสิทธิ์และการตั้งค่าของบริษัทที่เลือก',
    unknown:
      'ยังยืนยันผลการนำเข้าไม่ได้ โปรดตรวจประวัติก่อนนำเข้าอีกครั้ง เพราะข้อมูลบางส่วนอาจบันทึกแล้ว',
    'io-title': 'ผลประมวลผลเวลาเข้า–ออก',
    'io-scope':
      'ผลส่วนนี้รวมไฟล์ที่นำเข้าและข้อมูลเวลาค้างเดิมของบริษัทที่ยังไม่ได้ประมวลผล',
    row: 'แถว',
    validation: {
      required: 'กรุณาเลือกอย่างน้อยหนึ่งไฟล์',
      count: 'เลือกได้สูงสุด 10 ไฟล์',
      extension: 'รองรับเฉพาะไฟล์ TXT และ CSV',
      size: 'แต่ละไฟล์ต้องมีข้อมูลและมีขนาดไม่เกิน 5 MiB',
      total: 'ขนาดไฟล์รวมต้องไม่เกิน 20 MiB'
    },
    status: {
      'not-run': 'ยังไม่ได้ทำ',
      success: 'สำเร็จ',
      partial: 'มีข้อผิดพลาด',
      failed: 'ล้มเหลวหรือทำไม่ครบ',
      cancel: 'ยกเลิก',
      failure: 'ล้มเหลว',
      pending: 'รอดำเนินการ',
      partial_success: 'สำเร็จบางส่วน',
      duplicate: 'ข้อมูลซ้ำ',
      invalid: 'ข้อมูลไม่ถูกต้อง'
    }
  },
  form: {
    'time-attached-file-label': 'อัพโหลดไฟล์(.csv , .xlsx)'
  },
  'import-table': {
    row: 'แถว',
    empCode: 'รหัสพนักงาน',
    detail: 'รายละเอียด',
    status: 'สถานะ'
  }
}
